import { createAction } from "redux-actions";

import {
  createAsyncActions,
  runAsyncWorkflow
} from "../lib/reduxHelpers";

import { User, Book, Organisation } from "../api";

export const [
  fetchMe,
  receiveMe,
  fetchMeError
] = createAsyncActions(
  'ME',
  () => {},
  ({ data }) => ({ profile: data })
);

export const fetchMeWorkflow = (isRP = false) => {
  const fetchPromise = User.fetchMe(isRP);
  
  return runAsyncWorkflow({
    fetch: fetchMe,
    receive: receiveMe,
    error: fetchMeError
  }, fetchPromise);
}

export const [
  fetchNotifications,
  receiveNotifications,
  fetchNotificationsError
] = createAsyncActions(
  'FLASH_NOTIFICATIONS',
  () => {},
  () => {}
);

export const fetchNotificationsWorkflow = () => {
  const fetchPromise = User.fetchNotifications();
  
  return runAsyncWorkflow({
    fetch: fetchNotifications,
    receive: receiveNotifications,
    error: fetchNotificationsError
  }, fetchPromise);
}

export const [
  fetchPlatformNotifications,
  receivePlatformNotifications,
  fetchPlatformNotificationsError
] = createAsyncActions(
  'PLATFORM_NOTIFICATIONS',
  () => {},
  ({ data }) => ({ platformNotifications: data })
);

export const fetchPlatformNotificationsWorkflow = () => {
  const fetchPromise = User.fetchPlatformNotifications();
  
  return runAsyncWorkflow({
    fetch: fetchPlatformNotifications,
    receive: receivePlatformNotifications,
    error: fetchPlatformNotificationsError
  }, fetchPromise);
}

export const [
  markAllNotificationsAsRead,
  markAllNotificationsAsReadResponse,
  markAllNotificationsAsReadError
] = createAsyncActions(
  'MARK_ALL_NOTIFICATIONS_AS_READ',
  () => {},
  () => {}
);

export const markAllNotificationsAsReadWorkflow = () => {
  const fetchPromise = User.markAllNotificationsAsRead();
  
  return runAsyncWorkflow({
    fetch: markAllNotificationsAsRead,
    receive: markAllNotificationsAsReadResponse,
    error: markAllNotificationsAsReadError
  }, fetchPromise);
}

export const [
  markOneNotificationsAsRead,
  markOneNotificationsAsReadResponse,
  markOneNotificationsAsReadError
] = createAsyncActions(
  'MARK_ONE_NOTIFICATIONS_AS_READ',
  () => {},
  (data) => data
);

export const markOneNotificationsAsReadWorkflow = (id) => {
  const fetchPromise = User.markOneNotificationsAsRead(id);
  
  return runAsyncWorkflow({
    fetch: markOneNotificationsAsRead,
    receive: markOneNotificationsAsReadResponse,
    error: markOneNotificationsAsReadError
  }, fetchPromise, {notif_id: id});
}

export const [
  fetchLogout,
  receiveLogout,
  fetchLogoutError
] = createAsyncActions(
  'LOGOUT',
  () => {},
  () => {}
);

export const logoutWorkflow = () => {
  const fetchPromise = User.logout();
  
  return runAsyncWorkflow({
    fetch: fetchLogout,
    receive: receiveLogout,
    error: fetchLogoutError
  }, fetchPromise, {}, false);
}

export const [
  fetchUserLists,
  receiveUserLists,
  fetchUserListsError
] = createAsyncActions(
  'USER_LISTS',
  () => {},
  ({ ok, data }) => ({ lists: data })
);

export const fetchUserListsWorkflow = () => {
  const fetchPromise = User.fetchLists();

  return runAsyncWorkflow({
    fetch: fetchUserLists,
    receive: receiveUserLists,
    error: fetchUserListsError
  }, fetchPromise);
};

export const [
  deleteUserList,
  receiveDeleteUserList,
  deleteUserListError
] = createAsyncActions(
  'DELETE_USER_LIST',
  ({ listId }) => ({ listId }),
  ({ listId }) => ({ listId }),
  'DELETE'
);

export const deleteUserListWorkflow = listId => {
  const deleteUserListPromise = User.deleteList(listId);

  return runAsyncWorkflow(
    {
      fetch: deleteUserList,
      receive: receiveDeleteUserList,
      error: deleteUserListError
    },
    deleteUserListPromise,
    { listId }, 
    false
  );
};

export const [
  fetchChangeLanguage,
  receiveChangeLanguage,
  changeLanguageError
] = createAsyncActions(
  'CHANGE_LANGUAGE',
  () => {},
  ({ newLanguage }) => ({ newLanguage })
)

export const changeLanguage = (newLanguage, browserLang) => {
  const changeLanguagePromise = User.changeLanguage(newLanguage, browserLang)
    .then(() => {
      let oldLanguage =  localStorage.getItem('locale') || 'en';    
      let oldUrl = window.location.pathname + window.location.search + window.location.hash
      let language = ['ta', 'kn'].includes(newLanguage) ? 'en' : newLanguage
      localStorage.setItem('locale', language);
      localStorage.setItem('languageChange', "true");
          
      if (oldLanguage !== language){

        let reg1 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)$')
        let reg2 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)/')
        if(reg1.test(oldUrl)) {
          window.location.assign(oldUrl.replace(reg1, `/${language}`));
        }
        else if(reg2.test(oldUrl)){
          window.location.assign(oldUrl.replace(reg2, `/${language}/`));
        }
        else {
          window.location.assign(`/${language}/${oldUrl}`);
        }
      }
      return {}
    })

  return runAsyncWorkflow(
    {
      fetch: fetchChangeLanguage,
      receive: receiveChangeLanguage,
      error: changeLanguageError
    },
    changeLanguagePromise,
    { newLanguage },
    false
  )
}

export const openAuthModal = createAction('OPEN_AUTH_MODAL')
export const closeAuthModal = createAction('CLOSE_AUTH_MODAL')

export const [
  fetchOfflineChangePopUpStatus,
  receiveOfflineChangePopUpStatus,
  fetchOfflineChangePopUpStatusError
] = createAsyncActions(
  'CHANGE_OFFLINE_POPUP_STATUS',
  () => {},
  () => {}
);

export const changeOfflineBookPopUpStatusWorkflow = () => {
  const changeOfflinePopUpStatusPromise = User.changeOfflinePopUpStatus();

  return runAsyncWorkflow({
    fetch: fetchOfflineChangePopUpStatus,
    receive: receiveOfflineChangePopUpStatus,
    error: fetchOfflineChangePopUpStatusError
  }, changeOfflinePopUpStatusPromise);
};

export const [
  fetchUserFeedbackModalStatus,
  receiveUserFeedbackModalStatus,
  fetchUserFeedbackModalStatusError
] = createAsyncActions(
  'CHANGE_OFFLINE_POPUP_STATUS',
  () => {},
  () => {}
);

export const changeUserFeedbackModalStatusWorkflow = (feedbackType) => {
  const changeUserFeedbackModalStatusPromise = User.changeUserFeedbackModalStatus(feedbackType);

  return runAsyncWorkflow({
    fetch: fetchUserFeedbackModalStatus,
    receive: receiveUserFeedbackModalStatus,
    error: fetchUserFeedbackModalStatusError
  }, changeUserFeedbackModalStatusPromise);
};

export const [
  fetchEmailStatus,
  receiveEmailStatus,
  fetchEmailStatusError
] = createAsyncActions(
  'EMAIL_STATUS',
  () => {},
  () => {}
);

export const fetchEmailStatusWorkflow = (email) => {
  const fetchPromise = User.fetchEmailStatus(email)

  return runAsyncWorkflow({
    fetch: fetchEmailStatus,
    receive: receiveEmailStatus,
    error: fetchEmailStatusError
  }, fetchPromise)
}

export const [
  fetchLogin,
  receiveLogin,
  fetchLoginError
] = createAsyncActions(
  'LOGIN',
  () => {},
  () => {}
);

export const fetchLoginWorkflow = (email, password, rememberMe) => {
  const fetchPromise = User.login(email, password, rememberMe)

  return runAsyncWorkflow({
    fetch: fetchLogin,
    receive: receiveLogin,
    error: fetchLoginError
  }, fetchPromise)
}

export const [
  fetchLanguageOptions,
  receiveLanguageOptions,
  fetchLanguageOptionsError
] = createAsyncActions(
  'LANGUAGE_OPTIONS',
  () => {},
  ({ data }) => ({ queryValues: data.language.queryValues })
);

export const fetchLanguageOptionsWorkflow = () => {
  const fetchPromise = Book.fetchAllFilters()

  return runAsyncWorkflow({
    fetch: fetchLanguageOptions,
    receive: receiveLanguageOptions,
    error: fetchLanguageOptionsError
  }, fetchPromise)
}

export const [
  fetchOrganisationsOptions,
  receiveOrganisationsOptions,
  fetchOrganisationsOptionsError
] = createAsyncActions(
  'ORGANISATIONS_OPTIONS',
  () => {},
  ({ data }) => ({ data: data })
);

export const searchOrganisationsWorkflow = (searchValue) => {
  const fetchPromise = Organisation.search(searchValue)

  return runAsyncWorkflow({
    fetch: fetchOrganisationsOptions,
    receive: receiveOrganisationsOptions,
    error: fetchOrganisationsOptionsError
  }, fetchPromise)
}

export const [
  fetchSignup,
  receiveSignup,
  fetchSignupError
] = createAsyncActions(
  'SIGNUP',
  () => {},
  () => {}
);

export const fetchSignupWorkflow = (details) => {
  const fetchPromise = User.signup(details)

  return runAsyncWorkflow({
    fetch: fetchSignup,
    receive: receiveSignup,
    error: fetchSignupError
  }, fetchPromise)
}

export const [
  fetchForgotPassword,
  receiveForgotPassword,
  fetchForgotPasswordError
] = createAsyncActions(
  'FORGOT_PASSWORD',
  () => {},
  () => {}
)

export const fetchForgotPasswordWorkflow = (email) => {
  const fetchPromise = User.forgotPassword(email)

  return runAsyncWorkflow({
    fetch: fetchForgotPassword,
    receive: receiveForgotPassword,
    error: fetchForgotPasswordError
  }, fetchPromise)
}

export const [
  fetchResetPassword,
  receiveResetPassword,
  fetchResetPasswordError
] = createAsyncActions(
  'RESET_PASSWORD',
  () => {},
  () => {}
)

export const fetchResetPasswordWorkflow = (password, confirmPassword, resetPasswordToken) => {
  const fetchPromise = User.resetPassword(password, confirmPassword, resetPasswordToken)

  return runAsyncWorkflow({
    fetch: fetchResetPassword,
    receive: receiveResetPassword,
    error: fetchResetPasswordError
  }, fetchPromise)
}

export const [
  fetchResendConfirmationLink,
  receiveResendConfirmationLink,
  fetchResendConfirmationLinkError
] = createAsyncActions(
  'RESEND_CONFIRMATION_LINK',
  () => {},
  () => {}
)

export const fetchResendConfirmationLinkWorkflow = (email) => {
  const fetchPromise = User.resendConfirmationLink(email)

  return runAsyncWorkflow({
    fetch: fetchResendConfirmationLink,
    receive: receiveResendConfirmationLink,
    error: fetchResendConfirmationLinkError
  }, fetchPromise)
}

export const [
  fetchEmailConfirmation,
  receiveEmailConfirmation,
  fetchEmailConfirmationError
] = createAsyncActions(
  'EMAIL_CONFIRMATION',
  () => {},
  () => {}
)

export const fetchEmailConfirmationWorkflow = (confirmationToken) => {
  const fetchPromise = User.emailConfirmation(confirmationToken)

  return runAsyncWorkflow({
    fetch: fetchEmailConfirmation,
    receive: receiveEmailConfirmation,
    error: fetchEmailConfirmationError
  }, fetchPromise)
}

export const [
  fetchThirdPartyUserLogin,
  receiveThirdPartyUserLogin,
  receiveThirdPartyUserLoginError
] = createAsyncActions(
  'THIRD_PARTY_USER_LOGIN',
  () => {},
  () => {}
)

export const fetchThirdPartyUserLoginWorkflow = (confirmationToken) => {
  const fetchPromise = User.thirdPartyUserLogin(confirmationToken)

  return runAsyncWorkflow({
    fetch: fetchThirdPartyUserLogin,
    receive: receiveThirdPartyUserLogin,
    error: receiveThirdPartyUserLoginError
  }, fetchPromise);
}

export const [
  fetchFacebookAuth,
  receiveFacebookAuth,
  fetchFacebookAuthError
] = createAsyncActions(
  'FACEBOOK_AUTH',
  () => {},
  () => {}
)

export const fetchFacebookAuthWorkflow = (name, email, uid) => {
  const fetchPromise = User.facebookAuth(name, email, uid)

  return runAsyncWorkflow({
    fetch: fetchFacebookAuth,
    receive: receiveFacebookAuth,
    error: fetchFacebookAuthError
  }, fetchPromise)
}

export const [
  fetchGoogleAuth,
  receiveGoogleAuth,
  fetchGoogleAuthError
] = createAsyncActions(
  'GOOGLE_AUTH',
  () => {},
  () => {}
)

export const fetchGoogleAuthWorkflow = (name, email, uid) => {
  const fetchPromise = User.googleAuth(name, email, uid)

  return runAsyncWorkflow({
    fetch: fetchGoogleAuth,
    receive: receiveGoogleAuth,
    error: fetchGoogleAuthError
  }, fetchPromise)
}

export const [
  updateConsent,
  receiveupdateConsent,
  updateConsentError
] = createAsyncActions(
  'UPDATE_USER_CONSENT',
  () => {},
  () => {}
);

export const updateConsentWorkflow = () => {
  const updateConsentPromise = User.updateConsent();

  return runAsyncWorkflow(
    {
      fetch: updateConsent,
      receive: receiveupdateConsent,
      error: updateConsentError
    },
    updateConsentPromise
  );
};

export const updateActiveDropdownLink = createAction(
  'sw/UPDATE_ACTIVE_DROPDOWN_LINK'
  );

export const updateActiveMenuSelected = createAction(
  'sw/UPDATE_ACTIVE_MENU_SELECTED',
);

export const bottomMenuSelected = createAction(
  'sw/BOTTOM_MENU_SELECTED',
);

export const [
  postUserProfile,
  receivePostUserProfile,
  postUserProfileError
] = createAsyncActions(
  'USER_PROFILE',
  ({ user_type, description, user_id }) => ({ user_type, description, user_id }),
  ({ ok, data }) => ({ ok, data })
);
export const postUserProfileDataWorkflow = (user_type, description, user_id) => {
  const fetchPromise = User.submitUserProfile(user_type, description, user_id)
  return runAsyncWorkflow(
    {
      fetch: postUserProfile,
      receive: receivePostUserProfile,
      error: postUserProfileError
    },
    fetchPromise,
    { user_type, description, user_id }
  );
};

export const [
  postUserProfileData,
  receivePostUserProfileData,
  postUserProfileErrorData
] = createAsyncActions(
  'USER_PROFILE_DATA',
  ({ user_id }) => ({ user_id }),
  ({ data }) => ({ data : data })
);
export const updateUserProfileDataWorkflow = (user_id, data) => {
  const fetchPromise = User.saveUserProfileData(user_id, data)
  return runAsyncWorkflow(
    {
      fetch: postUserProfileData,
      receive: receivePostUserProfileData,
      error: postUserProfileErrorData
    },
    fetchPromise,);
};

export const [
  postOrganisationDetails,
  receiveOrganisationDetails,
  postOrganisationDetailsError
] = createAsyncActions(
  'Orgnisation_DATA',
  ({ data }) => ({ data : data })
);
export const saveOrganisationDetailsWorkflow = (data) => {
  const fetchPromise = User.saveOrganisation(data)
  return runAsyncWorkflow(
    {
      fetch: postOrganisationDetails,
      receive: receiveOrganisationDetails,
      error: postOrganisationDetailsError
    },
    fetchPromise,);
};


export const [
  postChangePassword,
  receiveChangePassword,
  postChangePasswordError
] = createAsyncActions(
  'USER_PROFILE_CHANGE_PASSWORD',
  ({ user_id }) => ({ user_id }),
  ({ data }) => ({ data : data })
);
export const changePasswordWorkflow = (user_id, data) => {
  const fetchPromise = User.changePassword(user_id, data)
  return runAsyncWorkflow(
    {
      fetch: postChangePassword,
      receive: receiveChangePassword,
      error: postChangePasswordError
    },
    fetchPromise,);
};

export const [
  fetchAutoCompleteUserData,
  receiveAutoCompleteUserData,
  fetchAutoCompleteUserDataError
] = createAsyncActions(
  'AUTOCOMPLETE_USER_DATA',
  () => {},
  ({ data }) => ({  data : data })
);

export const autoCompleteUserDataWorkflow = (user_type , searchValue) => {
  const fetchPromise = User.autoCompleteUserData(user_type , searchValue);
  
  return runAsyncWorkflow({
    fetch: fetchAutoCompleteUserData,
    receive: receiveAutoCompleteUserData,
    error: fetchAutoCompleteUserDataError
  }, fetchPromise);
}

export const [
  fetchOrganisationCountryDetails,
  receiveOrganisationCountryDetails,
  fetchOrganisationDetailsError
] = createAsyncActions(
  'FETCH_ORGANISATION_COUNTRY_DETAILS',
  () => {},
  ({ data }) => ({  data : data })
);

export const fetchOrganisationDetailsWorkflow = (org_name, countryName) => {
  const fetchPromise = User.fetchOrganisationDetails(org_name, countryName);
  
  return runAsyncWorkflow({
    fetch: fetchOrganisationCountryDetails,
    receive: receiveOrganisationCountryDetails,
    error: fetchOrganisationDetailsError
  }, fetchPromise);
}

export const [
  fetchOrganisationNames,
  receiveOrganisationNames,
  fetchOrganisationNameError
] = createAsyncActions(
  'FETCH_ORGANISATION_NAMES',
  ({ org_name }) => ({ org_name }),
  ({ data }) => ({  data : data })
);

export const fetchOrganisationNamesWorkflow = (org_name) => {
  const fetchPromise = User.fetchOrganisationNames(org_name);
  
  return runAsyncWorkflow({
    fetch: fetchOrganisationNames,
    receive: receiveOrganisationNames,
    error: fetchOrganisationNameError
  }, fetchPromise);
}

export const openUserProfileModal = createAction('sw/OPEN_USER_PROFILE_MODAL');
export const closeUserProfileModal = createAction('sw/CLOSE_USER_PROFILE_MODAL');
  
  
export const [
  fetchOTPSignup,
  receiveOTPSignup,
  fetchOTPSignupError
] = createAsyncActions(
  'FETCH_SIGNUP_OTP',
  () => { },
  () => { }
);

export const fetchOTPSignupWorkflow = (details) => {
  const fetchPromise = User.OTPSignup(details)

  return runAsyncWorkflow({
    fetch: fetchOTPSignup,
    receive: receiveOTPSignup,
    error: fetchOTPSignupError
  }, fetchPromise)
}

export const [
  fetchResendOTP,
  receiveResendOTP,
  fetchResendOTPError
] = createAsyncActions(
  'RESEND_OTP',
  () => { },
  () => { }
);

export const fetchResendOTPWorkflow = (phoneNumber, type) => {
  const fetchPromise = User.resendOTP(phoneNumber, type)

  return runAsyncWorkflow({
    fetch: fetchResendOTP,
    receive: receiveResendOTP,
    error: fetchResendOTPError
  }, fetchPromise)
}

export const [
  fetchPhoneNumberStatus,
  receivePhoneNumberStatus,
  fetchPhoneNumberStatusError
] = createAsyncActions(
  'PHONE_NUMBER_STATUS',
  () => { },
  () => { }
);

export const fetchPhoneNumberStatusWorkflow = (phoneNumber) => {
  const fetchPromise = User.fetchPhoneNumberStatus(phoneNumber)

  return runAsyncWorkflow({
    fetch: fetchPhoneNumberStatus,
    receive: receivePhoneNumberStatus,
    error: fetchPhoneNumberStatusError
  }, fetchPromise)
}

export const [
  fetchOTPLogin,
  receiveOTPLogin,
  fetchOTPLoginError
] = createAsyncActions(
  'OTP_LOGIN',
  () => { },
  () => { }
);

export const fetchOTPLoginWorkflow = (otp, phoneNumber) => {
  const fetchPromise = User.OTPLogin(otp, phoneNumber)

  return runAsyncWorkflow({
    fetch: fetchOTPLogin,
    receive: receiveOTPLogin,
    error: fetchOTPLoginError
  }, fetchPromise)
}

export const [
  fetchOTP,
  receiveOTP,
  fetchOTPError
] = createAsyncActions(
  'GENERATE_OTP',
  () => { },
  () => { }
);

export const fetchOTPWorkflow = (phoneNumber) => {
  const fetchPromise = User.generateOTP(phoneNumber)

  return runAsyncWorkflow({
    fetch: fetchOTP,
    receive: receiveOTP,
    error: fetchOTPError
  }, fetchPromise)
}

export const openDonateModal = createAction('OPEN_DONATE_MODAL');
export const closeDonateModal = createAction('CLOSE_DONATE_MODAL');

export const [
  fetchDonatePopUpStatus,
  receiveDonatePopUpStatus,
  fetchDonatePopUpStatusError
] = createAsyncActions(
  'UPDATE_DONATE_POPUP_STATUS',
  () => {},
  () => {}
);

export const updateDonatePopupStatusWorkFlow = () => {
  const fetchPromise = User.updateDonatePopupStatus();

  return runAsyncWorkflow({
    fetch: fetchDonatePopUpStatus,
    receive: receiveDonatePopUpStatus,
    error: fetchDonatePopUpStatusError
  }, fetchPromise);
};

export const [
  fetchAutoSuggestions,
  receiveAutoSuggestions,
  fetchAutoSuggestionsError
] = createAsyncActions(
  'AUTO_SUGGESTIONS',
  ({showLangSuggestion}) => ({showLangSuggestion}),
  ({ data, showLangSuggestion }) => ({ autoSuggestions: data.words, query: data.query, showLangSuggestion })
);

export const fetchAutoSuggestionsWorkflow = (value, showLangSuggestion=false, limit = 8) => {
  const fetchPromise = User.fetchAutoSuggestions(value, showLangSuggestion, limit);
  
  return runAsyncWorkflow({
    fetch: fetchAutoSuggestions,
    receive: receiveAutoSuggestions,
    error: fetchAutoSuggestionsError
  }, fetchPromise,
  {showLangSuggestion}
  );
}

export const [
  fetchUpdateWordSearchFrequency,
  receiveUpdateWordSearchFrequency,
  fetchUpdateWordSearchFrequencyError
] = createAsyncActions(
  'UPDATE_WORD_SEARCH_FREQUENCY',
  () => {},
  () => {}
);

export const updateWordSearchFrequencyWorkFlow = (id) => {
  const fetchPromise = User.updateWordSearchFrequency(id);

  return runAsyncWorkflow({
    fetch: fetchUpdateWordSearchFrequency,
    receive: receiveUpdateWordSearchFrequency,
    error: fetchUpdateWordSearchFrequencyError
  }, fetchPromise);
};

export const [
  fetchaddNewSearchWord,
  receiveaddNewSearchWord,
  fetchaddNewSearchWordError
] = createAsyncActions(
  'ADD_NEW_SEARCH_WORD',
  () => {},
  () => {}
);

export const addNewSearchWordWorkFlow = (value) => {
  const fetchPromise = User.addNewSearchWord(value);

  return runAsyncWorkflow({
    fetch: fetchaddNewSearchWord,
    receive: receiveaddNewSearchWord,
    error: fetchaddNewSearchWordError
  }, fetchPromise);
};

export const validateSearchWordWorkFlow = (value) => {
  const fetchPromise = User.validateSearchWord(value);

  return runAsyncWorkflow({
    fetch: fetchValidateSearchWord,
    receive: receiveValidateSearchWord,
    error: fetchValidateSearchWordError
  }, fetchPromise);
};

export const [
  fetchValidateSearchWord,
  receiveValidateSearchWord,
  fetchValidateSearchWordError
] = createAsyncActions(
  'ADD_VALIDATE_SEARCH_WORD',
  () => {},
  () => {}
);

export const [
  fetchTpStories,
  receiveTpStories,
  fetchTpStoriesError
] = createAsyncActions(
  'TP_STORIES',
  () => {},
  () => {}
);
export const getTPStoriesWorkflow = () => {
  const fetchPromise = User.getTpStories();
  
  return runAsyncWorkflow({
    fetch: fetchTpStories,
    receive: receiveTpStories,
    error:  fetchTpStoriesError
  }, fetchPromise);
}

export const openCbseRegisterModal = createAction('OPEN_CBSE_REGISTER_FORM');
export const closeCbseRegisterModal = createAction('CLOSE_CBSE_REGISTER_FORM');

export const [
  fetchRegisterCbseBookshelf,
  receiveRegisterCbseBookshelf,
  fetchRegisterCbseBookshelfError
] = createAsyncActions(
  'REGISTER_BOOKSHELF',
  ({user_id, list_id, grade, school,affiliation, city, state, user_name, lang, code}) => ({ user_id, list_id, grade, school, affiliation, city, state, user_name, lang, code}),
  ({ ok, data }) => ({ ok, data })
);
export const registerCbseBookshelf = ( user_id, list_id, grade, school, affiliation, city, state, user_name, lang, code) => {
  const fetchPromise = User.registerCbseBookshelf(  user_id, list_id, grade, school, affiliation, city, state, user_name, lang, code);
  
  return runAsyncWorkflow({
    fetch: fetchRegisterCbseBookshelf,
    receive: receiveRegisterCbseBookshelf,
    error:  fetchRegisterCbseBookshelfError
  }, fetchPromise);
}


export const [
  fetchStaticDataCbse,
  receiveStaticDataCbse,
  fetchStaticDataCbseError
] = createAsyncActions(
  'STATIC_DATA_CBSE',
  () => {},
  ({data}) => ({  data : data })
);
export const getStaticDataCbse = (user_id, campaign_type, list_id) => {
  const fetchPromise = User.getStaticDataCbse(user_id, campaign_type, list_id);
  
  return runAsyncWorkflow({
    fetch: fetchStaticDataCbse,
    receive: receiveStaticDataCbse,
    error: fetchStaticDataCbseError
  }, fetchPromise);
}

export const [
  fetchDonor,
  receiveDonor,
  fetchDonorError
] = createAsyncActions(
  'SUBMIT_DONOR_DETAILS',
  () => {},
  () => {}
);
export const submitDonorDetails = (details) => {
  const fetchPromise = User.submitDonorDetails(details);
  
  return runAsyncWorkflow({
    fetch: fetchDonor,
    receive: receiveDonor,
    error:  fetchDonorError
  }, fetchPromise);
}

export const openCampaignRegisterModal = createAction('OPEN_CAMPAIGN_REGISTER_FORM');
export const closeCampaignRegisterModal = createAction('CLOSE_CAMPAIGN_REGISTER_FORM');

export const [
  fetchRegisterCampaignBookshelf,
  receiveRegisterCampaignBookshelf,
  fetchRegisterCampaignBookshelfError
] = createAsyncActions(
  'REGISTER_BOOKSHELF',
  ({user_id, list_id, grade, school, block, city, district, state, user_name, lang, campaignType, autoEnroll}) => ({ user_id, list_id, grade, school, block, city, district, state, user_name, lang, campaignType, autoEnroll}),
  ({ ok, data }) => ({ ok, data })
);
export const registerCampaignBookshelf = ( user_id, list_id, grade, school, block, city, district, state, user_name, lang, campaignType, autoEnroll) => {
  const fetchPromise = User.registerCampaignBookshelf(  user_id, list_id, grade, school, block, city, district, state, user_name, lang, campaignType, autoEnroll);

  return runAsyncWorkflow({
    fetch: fetchRegisterCampaignBookshelf,
    receive: receiveRegisterCampaignBookshelf,
    error:  fetchRegisterCampaignBookshelfError
  }, fetchPromise);
}

export const [
  fetchCampaignCertificate,
  receiveCampaignCertificate,
  fetchCampaignCertificateError
] = createAsyncActions(
  'PROGRAM_CAMPAIGN_CERTIFICATE',
  () => {},
  ({data}) => ({  data : data })
);
export const getCampaignCertificate = (reg_id, certificateData) => {
  const fetchPromise = User.getCampaignCertificate(reg_id, certificateData);

  return runAsyncWorkflow({
    fetch: fetchCampaignCertificate,
    receive: receiveCampaignCertificate,
    error: fetchCampaignCertificateError
  }, fetchPromise);
}

export const [
  fetchUserCampaignData,
  receiveUserCampaignData,
  fetchUserCampaignDataError
] = createAsyncActions(
  'USER_CAMPAIGN_DATA',
  () => {},
  ({data}) => ({  data : data })
);
export const getUserCampaignData = (user_id, campaign_type, list_id) => {
  const fetchPromise = User.getUserCampaignData(user_id, campaign_type, list_id);
  
  return runAsyncWorkflow({
    fetch: fetchUserCampaignData,
    receive: receiveUserCampaignData,
    error: fetchUserCampaignDataError
  }, fetchPromise);
}


// WEBPACK FOOTER //
// ./src/redux/userActions.js